function showInsuranceToast(message) {
  const toast = document.getElementById('insurance-toast');
  if (!toast) return;

  toast.textContent = message;
  toast.style.opacity = 1;
  toast.style.pointerEvents = 'auto';

  setTimeout(() => {
    toast.style.opacity = 0;
    toast.style.pointerEvents = 'none';
  }, 3000);
}

function getToastText(added) {
  const lang = document.documentElement.lang || 'en';
  const isItalian = lang.toLowerCase().startsWith('it');

  if (added) {
    return isItalian ? '✅ Assicurazione spedizione aggiunta' : '✅ Shipping insurance added';
  } else {
    return isItalian ? '❌ Assicurazione spedizione rimossa' : '❌ Shipping insurance removed';
  }
}

function initInsuranceToggle(checkbox) {
  if (!checkbox || checkbox.dataset.listenerAttached) return;

  const insuranceVariantId = 52278795043156;
  checkbox.dataset.listenerAttached = "true";

  // Pre-check on load
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const insuranceItem = cart.items.find(item => item.variant_id === insuranceVariantId);
      checkbox.checked = !!insuranceItem;
    });

  checkbox.addEventListener("change", function () {
    if (this.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: insuranceVariantId, quantity: 1 })
      })
      .then(() => {
        showInsuranceToast(getToastText(true));
      })
      .catch(err => {
        console.error("Failed to add insurance:", err);
        checkbox.checked = false;
      });
    } else {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const insuranceItem = cart.items.find(item => item.variant_id === insuranceVariantId);
          if (insuranceItem) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: insuranceItem.key, quantity: 0 })
            })
            .then(() => {
              showInsuranceToast(getToastText(false));
            })
            .catch(err => {
              console.error("Failed to remove insurance:", err);
              checkbox.checked = true;
            });
          }
        });
    }
  });
}

function initDropshippingToggle(checkbox) {
  if (!checkbox || checkbox.dataset.listenerAttached) return;

  const dropshippingVariantId = 51845268701524;
  checkbox.dataset.listenerAttached = "true";

  // Pre-check on load
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const dropshippingItem = cart.items.find(item => item.variant_id === dropshippingVariantId);
      checkbox.checked = !!dropshippingItem;
    });

  checkbox.addEventListener("change", function () {
    if (this.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: dropshippingVariantId, quantity: 1 })
      })
      .then(() => {
        const msg = document.documentElement.lang.startsWith('it')
          ? '✅ Questo è un ordine dropshipping'
          : '✅ This is a Dropshipping order';
        showInsuranceToast(msg);
      })
      .catch(err => {
        console.error("Failed to add dropshipping item:", err);
        checkbox.checked = false;
      });
    } else {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const dropshippingItem = cart.items.find(item => item.variant_id === dropshippingVariantId);
          if (dropshippingItem) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: dropshippingItem.key, quantity: 0 })
            })
            .then(() => {
              const msg = document.documentElement.lang.startsWith('it')
                ? '❌ Non è un ordine dropshipping'
                : '❌ This is not a Dropshipping order';
              showInsuranceToast(msg);
            })
            .catch(err => {
              console.error("Failed to remove dropshipping item:", err);
              checkbox.checked = true;
            });
          }
        });
    }
  });
}

function attachToggles() {
  const insuranceDrawer = document.getElementById("drawer-insurance-toggle");
  const insuranceCart = document.getElementById("cart-insurance-toggle");
  if (insuranceDrawer) initInsuranceToggle(insuranceDrawer);
  if (insuranceCart) initInsuranceToggle(insuranceCart);

  const dropshippingDrawer = document.getElementById("drawer-dropshipping-toggle");
  const dropshippingCart = document.getElementById("cart-dropshipping-toggle");
  if (dropshippingDrawer) initDropshippingToggle(dropshippingDrawer);
  if (dropshippingCart) initDropshippingToggle(dropshippingCart);
}

const observer = new MutationObserver(attachToggles);
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("DOMContentLoaded", attachToggles);
